import { render, staticRenderFns } from "./KSteelCodeGuide.vue?vue&type=template&id=2072c0c3&"
import script from "./KSteelCodeGuide.vue?vue&type=script&lang=js&"
export * from "./KSteelCodeGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports